import React, { useState, useEffect } from 'react';
import { translatedMessage } from '../../service/LanguageService';

const CompetitionWorkDurationViewComponent = (props) => {
    const [competition, setCompetition] = useState(null);

    useEffect(() => {
        const getCompetition = async () => {
            // console.log(props?.competition);
            setCompetition(props?.competition);
        };

        getCompetition();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    return (
        <>
            <div className='col-12 mt-2'>
                <h5 className='mb-0'>{translatedMessage('job.workingHours')}</h5>                
            </div>
            <div className='col-12'>
                {competition?.workingHours !== null ? competition?.workingHours.label : "-"}
            </div>
        </>
    );
};

export default CompetitionWorkDurationViewComponent;
